import React, { Component } from "react";

class LocationsSideNav extends Component {
  render() {
    //const that = this;

    return (
      <div>
        {this.props.items.map((item, index) => (
          <div
            className="citycard"
            key={item.id}
            /* onClick={this.props.checkDelete.bind(item.id)}*/
          >
            <div className="icon-holder">
              <img
                src={
                  "http://openweathermap.org/img/wn/" + item.icon + "@2x.png"
                }
              />
            </div>

            <div
              className="delete-Btn"
              onClick={this.props.checkDelete.bind(this, item)}
            >
              X
            </div>
            <div className="card-text-all">
              <div className="citycard-title">{item.name}</div>
              <br />
              <div className="citycard-temp">
                {Math.floor(item.temp)} °C - {item.description}
              </div>
              <br />
              <div>
                Min: {Math.floor(item.temp_min)}°C Max:{" "}
                {Math.floor(item.temp_max)}°C
              </div>
              <div>Wind: {item.windSpeed} m/sec</div>
            </div>
            {/* 
            <h5>ID: {item.id}</h5>
            <h5>Lat: {item.latitude}</h5>
            <h5>Lon: {item.longitude}</h5>
          */}
          </div>
        ))}
      </div>
    );
  }
}

export default LocationsSideNav;
